import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { Address1_2, Address2 } from "../../assets/data/Constants";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkPrefecturesPick from "../../components/molecules/TkPrefecturesPick";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_MAI001_Response } from "../../type/apiType";
import { httpAPI_MAI001, httpAPI_MAI003 } from "./api/request";
import { Address2Component } from "./components/components";
import { schema, tableList } from "./parts";
import _ from "lodash";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { FormHelperText } from "@mui/material";

/**
 * SCRW130003 メール新規作成
 * @return SCRW130003
 */
const SCRW130003 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const [stateTableList, setStateTableList] = useState<any>([]);
  const [resInit, setResInit] = useState<IAPI_MAI001_Response>({});
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState<any>({});
  const [prefectures, setPrefectures] = useState<any>([]);
  const [resData, setResData] = useState<any>();
  const stateFakeTableList = useRef(_.cloneDeep(tableList));
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    handleCallApiInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCallApiInit = async () => {
    // メール参照API 呼び出し
    try {
      const res = await httpAPI_MAI001({
        emailId: location.state?.emailId,
        emailAddress: location.state?.emailAddress,
      });

      // 初期表示
      if (res.resultCd === "I0000") {
        let table = stateFakeTableList.current;

        for (let i in res) {
          let index = i as keyof typeof res;
          let targetObj = table.find((item) => item.keyword === index)!;

          targetObj && (targetObj.setDefaultValue = res[index]);
          targetObj && (targetObj.text = res[index]);
        }

        setStateTableList([...table]);

        setResData(res);
        let addressKbn1 = table.find((item) => item.keyword === "addressKbn1")!;
        let tempName = table.find((item) => item.keyword === "tempName")!;
        let title = table.find((item) => item.keyword === "title")!;
        let text = table.find((item) => item.keyword === "text")!;
        if (location.state?.emailId) {
          addressKbn1.disabled = true;
          title.disabled = true;
          text.disabled = true;
        }

        table.find((item) => item.keyword === "addressKbn1")!.onGetValue = (
          value: any
        ) => {
          tempName.setDefaultValue = "";
          title.setDefaultValue = "";
          text.setDefaultValue = "";
          if (value === Address1_2["個別に宛先を入力"]) {
            title.disabled = false;
            text.disabled = false;
          } else {
            title.disabled = true;
            text.disabled = true;
          }
          setAddress1(value);
        };
        tempName.onGetValue = (id: any) => {
          tempName.setDefaultValue = id;
          let target = res.emailTempList?.find((item) => item.tempId === id);

          if (target) {
            title.setDefaultValue = target.title;
            text.setDefaultValue = target.text;
          } else {
            title.setDefaultValue = "";
            text.setDefaultValue = "";
          }
          setStateTableList([...table]);
        };

        setResInit(res);
        setAddress1(res.addressKbn1 ?? "");
        setAddress2({ addressKbn2: res.addressKbn2 });
        setPrefectures(res.prefectureCdList);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else if (res.resultCd === "TKMSG_SVR0017W") {
        let table = stateFakeTableList.current;
        setStateTableList([...table]);
        let tempName = table.find((item) => item.keyword === "tempName")!;

        table.find((item) => item.keyword === "addressKbn1")!.onGetValue = (
          value: any
        ) => {
          tempName.setDefaultValue = "";
          setAddress1(value);
        };

        setResInit(res);
        setAddress1("");
        setAddress2({});
        setPrefectures([]);

        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    let table = stateFakeTableList.current;
    let prefectures = table.find((item) => item.keyword === "prefectures")!;
    prefectures.showLine = false;
    let addressKbn2 = table.find((item) => item.keyword === "addressKbn2")!;
    addressKbn2.onGetValue = () => {
      setErrorMsg("");
    };
    let flg1 = address1 === Address1_2["個別に宛先を入力"];
    let flg2 = address1 === Address1_2["個別に宛先を指定"];
    let flg3 = address1 === Address1_2["既存の宛先を選択"];
    if (flg2 && !address2.corpName) {
      setErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));
    } else {
      setErrorMsg("");
    }
    addressKbn2.node = (
      <Box>
        <Address2Component
          address1={address1}
          defaultValue={resInit}
          disabled={false}
          onChange={(e: any) => setAddress2(e)}
        />
        {errorMsg && flg2 && <FormHelperText error>{errorMsg}</FormHelperText>}
      </Box>
    );
    let tempName = table.find((item) => item.keyword === "tempName")!;
    let allEmailTempList = resData?.emailTempList;
    tempName.selectPropsList = [];
    if (flg1) {
      tempName.requiredIcon = false;
      tempName.selectPropsList =
        allEmailTempList
          ?.filter((item: any) => item.tempId === 76)
          ?.map((item: any) => {
            return {
              label: item.tempName,
              value: item.tempId,
            };
          }) ?? [];
    } else if (flg2 || flg3) {
      tempName.requiredIcon = true;
      tempName.selectPropsList =
        allEmailTempList
          ?.filter((item: any) => item.tempId !== 76)
          ?.map((item: any) => {
            return {
              label: item.tempName,
              value: item.tempId,
            };
          }) ?? [];
    }
    setStateTableList([...table]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resInit, address1, errorMsg, address2]);

  useEffect(() => {
    let table = stateFakeTableList.current;
    let prefectures = table.find((item) => item.keyword === "prefectures")!;
    let flg =
      address2.addressKbn2 ===
      Address2["都道府県（施設の所在地）単位の共済契約者"];

    // 都道府県
    prefectures.showLine = flg;
    flg &&
      (prefectures.node = (
        <TkPrefecturesPick
          onSuccessful={(e: any) =>
            setPrefectures(
              e.map((item: any) => {
                return { prefectureCd: item };
              })
            )
          }
        />
      ));

    setStateTableList([...table]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address2]);

  const handleSubmit = async (data: any) => {
    let flg1 = address1 === Address1_2["既存の宛先を選択"];
    let flg2 = address1 === Address1_2["個別に宛先を指定"];
    let flg3 = address1 === Address1_2["個別に宛先を入力"];
    if (flg1 && !address2.addressKbn2) {
      return;
    }
    if (flg2 && !address2.corpName) {
      setErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));
      return;
    }
    if (flg3 && !address2.email) {
      return;
    }
    // メール更新API 呼び出し
    try {
      const res = await httpAPI_MAI003({
        addressKbn1: data?.addressKbn1,
        addressKbn2: address2?.addressKbn2,
        prefectureCdList: prefectures,
        contractorNo:
          address1 === Address1_2["個別に宛先を入力"]
            ? location?.state?.contractorNo
            : address2?.contractorNo,
        corpName: address2?.corpName,
        email: address2?.email,
        title: data?.title,
        text: data?.text,
        tempId: data?.tempName,
        taskId: location.state?.taskId,
        emailId: location.state?.emailId,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRW130002");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRW130003">
      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        buttonGroup={<TkBackButton />}
        submitButtonText="メール送信"
        onCheckAndSubmit={handleSubmit}
      />
    </Box>
  );
};

export default SCRW130003;
